import { MachineApprovalStatus } from '../../constants/machine/machine.constant';
import {
  IUserOwnTractorFilter,
  userOwnTractorFilterKeyType,
} from '../../constants/filter/userOwnTractorFilter.constant';
import { filterSliderConstant } from '../../constants/filter/slider/filterSliderConstant';

interface ICreateUserOwnTractorFilterSearchParamsParam {
  filters: IUserOwnTractorFilter[];
}

interface ICreateUserOwnTractorFilterSearchParamsReturn {
  machineApprovalStatus: string;
  isPokeEnabled: boolean;
  sort: string;
  minEngineOutputPs: number;
  maxEngineOutputPs: number;
  brand: string;
  regionDepth1: string;
}

export const createUserOwnTractorFilterSearchParams = ({
  filters,
}: ICreateUserOwnTractorFilterSearchParamsParam): ICreateUserOwnTractorFilterSearchParamsReturn => {
  const { APPROVAL, PSWAITING } = MachineApprovalStatus;
  const ENGINE_OUTPUT_PS_MIN = filterSliderConstant.engineOutputInPs.min;
  const ENGINE_OUTPUT_PS_MAX = filterSliderConstant.engineOutputInPs.max;

  const getFilterOptionValues = (filterKey: userOwnTractorFilterKeyType) =>
    filters
      .find((filter) => filter.key === filterKey)
      ?.options.filter((option) => option.isSelected)
      .map((option) => option.value)
      .join(',');

  const sorterFilterOptionValues = getFilterOptionValues('sorter');
  const brandFilterOptionValues = getFilterOptionValues('filter_brand');
  const engineOutputPsFilterOptionValues = getFilterOptionValues('engineOutputInPs');
  const regionFilterOptionValues = getFilterOptionValues('filter_region');

  const engineOutputPsMin = Number(engineOutputPsFilterOptionValues?.split(',')[0]);
  const engineOutputPsMax = Number(engineOutputPsFilterOptionValues?.split(',')[1]);

  let machineApprovalStatus = APPROVAL;
  if (engineOutputPsMin === ENGINE_OUTPUT_PS_MIN && engineOutputPsMax === ENGINE_OUTPUT_PS_MAX) {
    machineApprovalStatus += `,${PSWAITING}`;
  }

  return {
    machineApprovalStatus,
    isPokeEnabled: true,
    sort: sorterFilterOptionValues ?? '',
    minEngineOutputPs: engineOutputPsMin ?? 0,
    maxEngineOutputPs: engineOutputPsMax ?? 0,
    brand: brandFilterOptionValues ?? '',
    regionDepth1: regionFilterOptionValues ?? '',
  };
};
